import React, { useEffect, useContext } from 'react'
import LoginBody from '../login/LoginBody'

import Error from './Error'
import Forgot from './Forgot'
import Reset from './Reset'
import EmailValidate from './EmailValidate'
import CallbackPage from './CallBackPage'
import User from './User'
import SsoConnectPage from './SsoConnectPage'
import ResultPage from './ResultPage'
import { useFetch } from "../../Utils/Hooks/useFetch";
import { appContext } from "../../AppContext";


import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import UserManagment from './UserManagement'
import PrivateRoute from './PrivateRoute'
import Logout from './Logout'
import LoginRoute from './LoginRoute'

export default function AppRouter () {
    const validateSsoToken = new URLSearchParams(window.location.search).get("token")

    const [doFetch] = useFetch();
    //eslint-disable-next-line
    const [appState, AppDispatch] = useContext(appContext);

    useEffect(() => {
        doFetch(`/Configuration/GetLockoutTime`)
        .then((response) => {
          if(response.isSuccess) {
            AppDispatch({ type: "SETLOCKOUTTIME", payload: response.result.paramValue });
          }
        })
    }, //eslint-disable-next-line 
    [])
 
    return (
        <Router basename={`${process.env.PUBLIC_URL}`}>
            <Switch>
                <LoginRoute path="/error">
                    <Error />
                </LoginRoute>
                <LoginRoute path="/forgot-password">
                    <Forgot />
                </LoginRoute>
                <LoginRoute path="/reset-password">
                    <Reset />
                </LoginRoute>
                <LoginRoute path="/validate-email">
                    <EmailValidate />
                </LoginRoute>
                <PrivateRoute path="/user-management/user">
                    <User />
                </PrivateRoute> 
                <PrivateRoute path="/user-management" hasSearchBar={true}> 
                    <UserManagment />
                </PrivateRoute>
                <Route path="/logout"> 
                    <Logout />
                </Route>
                <LoginRoute path="/connect-sso">
                    <SsoConnectPage token={validateSsoToken}/>
                </LoginRoute>
                <Route path="/callback" component={CallbackPage} />
                <LoginRoute path="/result">
                    <ResultPage />
                </LoginRoute>
                <LoginRoute path="/">
                    <LoginBody />
                </LoginRoute>
            </Switch>
        </Router>
    )
}